import React, { useState, FormEvent } from 'react';
import { render } from 'react-dom';
import RowTemplate from '../../atoms/RowTemplate';

const MypageOpeningPreliminary: React.FC = () => {
  return (
    <>
      <div className="container">
        <h4 className="title p-2 my-5">マイページ開設</h4>
        <div>
          <p className="p-lead">
            メールアドレス、パスワードを入力してマイページを開設して下さい。
          </p>
        </div>
        <div>
          <form className="form" action="" method="">
            <RowTemplate
              label="ログインID"
              content={
                <div className="p-title-with-input">
                  <div className="p-text-with-input">
                    <div className="text-with-input-box">
                      <input
                        className="c-input input-l"
                        type="text"
                        placeholder="example@example.com"
                      />
                    </div>
                    <span className="c-annotation">
                      ※今後こちらのメールアドレス宛に重要なお知らせをお届けします。入力内容に間違いのないことを必ず確認して下さい。
                    </span>
                  </div>
                </div>
              }
            />
            <RowTemplate
              label="パスワード"
              content={
                <div className="p-title-with-input">
                  <div className="p-text-with-input">
                    <div className="text-with-input-box">
                      <input className="c-input input-l" type="password" placeholder="XXXXXX" />
                    </div>
                  </div>
                </div>
              }
            />
            <RowTemplate
              label="パスワード(確認用)"
              content={
                <div className="p-title-with-input">
                  <div className="p-text-with-input">
                    <div className="text-with-input-box">
                      <input className="c-input input-l" type="password" placeholder="XXXXXX" />
                    </div>
                  </div>
                </div>
              }
            />
            <p>
              <span className="c-annotation">
                ※パスワードは、英字・数字を含む8文字以上で設定して下さい。
              </span>
            </p>
            <div className="p-next-btn-box">
              <button
                className="c-btn btn-max btn-main-color btn-arrow-right"
                type="button"
                data-jump_to="#"
              >
                マイページを開設する
              </button>
            </div>
          </form>

          <div className="row">
            <div className="col-md-4">
              <div className="p-back-btn-box">
                <a className="c-btn btn-large btn-main-color" data-back>
                  戻る
                </a>
              </div>
            </div>
            <div className="col-md-4 ml-auto"></div>
          </div>
        </div>
      </div>
    </>
  );
};

if (document.getElementById('guarantor-agreement-mypage-opening')) {
  render(
    <MypageOpeningPreliminary />,
    document.getElementById('guarantor-agreement-mypage-opening')
  );
}
